let orderMgt = [
  {
    path: 'orderMgt',
    meta: {
      title: '订单管理',
      breadcrumb: true
    },
    component: {
      name: 'orderMgt',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '订单管理',
        },
        component: (resolve) => require(['@/views/plat/orderManagement/orderMgt'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/orderManagement/orderMgt/detail'], resolve)
      },
    ]
  },
  {
    path: 'orderShipping',
    meta: {
      title: '订单发货',
      breadcrumb: true
    },
    component: {
      name: 'orderShipping',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '订单发货',
        },
        component: (resolve) => require(['@/views/plat/orderManagement/orderShipping'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/orderManagement/orderMgt/detail'], resolve)
      },
	  {
	    path: 'proxyAdd',
	    meta: {
	      title: "创建微代理",
	      breadcrumb: true,
	    },
	    component: (resolve) => require(['@/views/plat/orderManagement/orderShipping/proxyAdd'], resolve)
	  },
	  {
	    path: 'ouletAdd',
	    meta: {
	      title: "创建商家",
	      breadcrumb: true,
	    },
	    component: (resolve) => require(['@/views/plat/orderManagement/orderShipping/outletAdd'], resolve)
	  },
	  {
	    path: 'ouletAddex',
	    meta: {
	      title: "创建商家",
	      breadcrumb: true,
	    },
	    component: (resolve) => require(['@/views/plat/orderManagement/orderShipping/outletAddex'], resolve)
	  },
    ]
  },
  {
    path: 'bookingForm',
    meta: {
      title: '预约单',
      breadcrumb: true
    },
    component: {
      name: 'bookingForm',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '预约单',
        },
        component: (resolve) => require(['@/views/plat/orderManagement/bookingForm'], resolve)
      }
    ]
  },
  {
    path: 'mwwdOrderMgt',
    meta: {
      title: '云仓订单管理',
      breadcrumb: true
    },
    component: {
      name: 'mwwdOrderMgt',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '云仓订单管理',
        },
        component: (resolve) => require(['@/views/plat/orderManagement/mwwdOrderMgt'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/orderManagement/mwwdOrderMgt/detail'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: "新建",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/orderManagement/mwwdOrderMgt/add'], resolve)
      },
    ]
  },
  {
    path: 'mwwdOrderSend',
    meta: {
      title: '云仓订单发货',
      breadcrumb: true
    },
    component: {
      name: 'mwwdOrderSend',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '云仓订单发货',
        },
        component: (resolve) => require(['@/views/plat/orderManagement/mwwdOrderSend'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/orderManagement/mwwdOrderMgt/detail'], resolve)
      },
    ]
  },
  {
    path: 'planActivateMgt',
    meta: {
      title: '方案激活管理',
      breadcrumb: true
    },
    component: {
      name: 'planActivateMgt',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '方案激活管理',
        },
        component: (resolve) => require(['@/views/plat/orderManagement/planActivateMgt'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/orderManagement/planActivateMgt/detail'], resolve)
      }
    ]
  },
]

export default {
  path: '/orderManagement',
  redirect: '/orderManagement/orderMgt',
  meta: {
      title: "订单管理",
      breadcrumb: true
  },
  component: {
      name: 'orderManagement',
      template: '<router-view></router-view>'
  },
  children: orderMgt
}


// WEBPACK FOOTER //
// ./src/router/orderManagement.js